module.exports = __webpack_public_path__ + "static/media/4.14875110.png";